// card-product-carousel.js
// Handles image carousel for product cards with .card__arrows-overlay

document.addEventListener('DOMContentLoaded', function () {
  initCardProductCarousel();
  // In case of dynamic section loads (Shopify)
  document.addEventListener('shopify:section:load', initCardProductCarousel);
});

function initCardProductCarousel() {
  // For each product card
  document.querySelectorAll('.product-card-wrapper').forEach(function (card) {
    const mediaContainer = card.querySelector('.card__media .media');
    if (!mediaContainer) return;

    // Gather all images in the card's media
    const images = Array.from(mediaContainer.querySelectorAll('img'));
    if (images.length <= 1) return; // No carousel needed

    // Set initial state
    let currentIndex = 0;
    images.forEach((img, idx) => {
      if (idx === 0) {
        img.style.opacity = '1';
        img.style.display = '';
      } else {
        img.style.opacity = '0';
        img.style.display = 'none';
      }
      img.style.transition = 'opacity 0.3s ease';
      img.setAttribute('data-carousel-index', idx);
    });
    
    // Store current state in card
    card.setAttribute('data-carousel-current', '0');

    // Arrow buttons
    const leftArrow = card.querySelector('.card__arrow--left');
    const rightArrow = card.querySelector('.card__arrow--right');
    if (!leftArrow || !rightArrow) return;

    // Remove any existing event listeners
    leftArrow.onclick = null;
    rightArrow.onclick = null;

    leftArrow.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      updateCarousel();
    });

    rightArrow.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      currentIndex = (currentIndex + 1) % images.length;
      updateCarousel();
    });

    function updateCarousel() {
      images.forEach((img, idx) => {
        if (idx === currentIndex) {
          img.style.display = '';
          setTimeout(() => {
            img.style.opacity = '1';
          }, 50);
        } else {
          img.style.opacity = '0';
          setTimeout(() => {
            if (idx !== currentIndex) { // Check again in case of rapid clicks
              img.style.display = 'none';
            }
          }, 300); // Match transition duration
        }
      });
      card.setAttribute('data-carousel-current', currentIndex);
    }
  });
}
